<template>
    <div>
        <div class="border rounded p-50 m-50">
            <v-file-uploader :value="file" :accept="['pdf','doc','docx','xls','xlsx','png','jpg','jpeg']" valueParameter="File"></v-file-uploader>
            <v-executer full-width :loading="uploading" :disabled="file.File == null" class="mt-1" text="Yükle" :action="upload"></v-executer>
        </div>        

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    pagination="server"
                    :buttons="buttons"
                    :settings="false"></v-table>
    </div>
    
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
import Additional from '@/utilities/additional'

export default {
    components:{
        VFileUploader
    },
    props:{
        value:Object
    },
    data(){
        return{
            fields:[
                {name:'Dosya',key:'Name',thClass:'w-100'}
            ],
            file:{
                EmployeeId:null,
                EmployeeLevyId:null,
                File:null,
            },
            uploading:false,
            buttons:[
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
        }
    },
    methods:{
        provider(data){
            return EmployeeOperationsApi.Levy.File.Table({
                ...data,
                EmployeeLevyId:this.value.Id
            })
        },
        clearForm(){
            this.file.EmployeeId = null
            this.file.EmployeeLevyId = null
            this.file.File = null
        },
        async upload(){
            this.uploading = true
            this.file.EmployeeId = this.value.EmployeeId
            this.file.EmployeeLevyId = this.value.Id
            let formData = await Additional.ToFormData(this.file,['File'])
            EmployeeOperationsApi.Levy.File.Upload(formData).then(res=>{
                this.$result(res)
                this.uploading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.clearForm()
                }
            }).catch(err=>{
                this.$result(null,err)
                this.uploading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.FileName} isimli dosyayı silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    EmployeeOperationsApi.Levy.File.Delete(item.FileId).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>